import { Box, CircularProgress, Typography } from '@mui/material';
import React, { useEffect, useRef } from 'react'
import { routes } from '../../../utils/routes';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../store/store';
import { exchangeReconnectGBPTokenAction } from '../../../redux/actions/AuthActionsNew';

const GoogleBusinessReconnectSuccess = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const hasCalledAPI = useRef(false);

    const workspaceId = localStorage.getItem("activeWorkspaceId");

    useEffect(() => {
        // Extract tokens immediately to avoid stale closures
        const bridgeToken = searchParams.get('bridge_token');
        const code = searchParams.get('code');
        // const businessId = localStorage.getItem('selecetd');


        // Prevent multiple API calls
        if (hasCalledAPI.current) {
            return;
        }

        // for fecth google business for Check-ins
        if (bridgeToken && code && workspaceId) {
            hasCalledAPI.current = true;

            dispatch(exchangeReconnectGBPTokenAction({ bridge_token: bridgeToken, code: code, workspaceId: workspaceId || "" }))
                .unwrap()
                .then((res) => {
                    if (res.success) {
                        navigate(routes?.businessdashboard, {
                            replace: true,
                            state: { fromGBPReconnect: true }
                        });
                    } else {
                        navigate(routes?.businessdashboard, { replace: true });
                    }
                })
                .catch((e) => {
                    console.error("API Error:", e);
                    hasCalledAPI.current = false; // Reset on error to allow retry
                    navigate(routes.businessdashboard, { replace: true });
                });
        } else {
            navigate(routes.businessdashboard, { replace: true });
        }

    }, [searchParams, navigate, dispatch]);

    return (
        <Box
            sx={{
                height: '100vh',
                width: '100vw',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#f4f6f8',
            }}
        >
            <CircularProgress size={60} thickness={5} />
            <Typography mt={2} variant="h6" sx={{ color: '#555' }}>
                Authenticating...
            </Typography>
        </Box>
    )
}

export default GoogleBusinessReconnectSuccess